// Shared month filter options and time grouping for event lists
// (single source of truth for Events.js and Sports.js)

// Multi-selectable month filter options. monthCount should cover the page's
// event-creation window: today + N months can land in the (N+1)th calendar
// month, so pass N+1 (Events: 7 for its 6-month window; Sports: 3 for 2).
// value: 'YYYY-MM' (matches event.date.slice(0, 7)); label shows the year
// only when it differs from the current year (e.g. '2027年1月').
export const getMonthOptions = (monthCount = 7, now = new Date()) => {
  const options = [];
  for (let i = 0; i < monthCount; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
    const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    const label = d.getFullYear() === now.getFullYear()
      ? `${d.getMonth() + 1}月`
      : `${d.getFullYear()}年${d.getMonth() + 1}月`;
    options.push({ label, value });
  }
  return options;
};

// Local-timezone YYYY-MM-DD (avoid toISOString UTC shift)
export const toDateString = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

// Group upcoming events (already sorted by date ascending) into display
// sections: 本週 (through this Sunday, week starts Monday) / 下週 / 本月 / 之後.
// Empty sections are omitted. Events with dates before today are assumed
// to be filtered out by the caller.
export const groupEventsByTime = (events, now = new Date()) => {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // Days until this Sunday (Monday-based week): Sunday itself counts as 0
  const daysToSunday = (7 - today.getDay()) % 7;
  const endOfThisWeek = new Date(today);
  endOfThisWeek.setDate(today.getDate() + daysToSunday);
  const endOfNextWeek = new Date(endOfThisWeek);
  endOfNextWeek.setDate(endOfThisWeek.getDate() + 7);
  const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const thisWeekStr = toDateString(endOfThisWeek);
  const nextWeekStr = toDateString(endOfNextWeek);
  const monthStr = toDateString(endOfMonth);

  const sections = [
    { label: '本週', events: [] },
    { label: '下週', events: [] },
    { label: '本月', events: [] },
    { label: '之後', events: [] }
  ];

  events.forEach(event => {
    const d = event.date || '';
    if (d <= thisWeekStr) sections[0].events.push(event);
    else if (d <= nextWeekStr) sections[1].events.push(event);
    else if (d <= monthStr) sections[2].events.push(event);
    else sections[3].events.push(event);
  });

  return sections.filter(section => section.events.length > 0);
};
